import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@material-ui/core';
import { createStyles, withStyles, darken, Theme, WithStyles } from '@material-ui/core/styles';

import { useContent } from 'hooks';
import { ExternalLink } from './index';
import { getNetworkName } from '../helpers';

const styles = (theme: Theme) =>
  createStyles({
    button: {
      margin: `${theme.spacing(1)}px 0 ${theme.spacing(2)}px`,
      borderColor: theme.palette.primary.main,
      color: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: 'transparent',
        borderColor: darken(theme.palette.primary.main, 0.1),
        color: darken(theme.palette.primary.main, 0.1),
      },
    },
  });

const Engage: FC<WithStyles<typeof styles>> = ({ classes }) => {
  const content = useContent();

  if (!content.is_engage) {
    return null;
  }

  const { t } = useTranslation();
  const networkName = getNetworkName(content);

  return (
    <ExternalLink>
      <Button fullWidth variant="outlined" className={classes.button}>
        {t('content:engageOnX', { networkName })}
      </Button>
    </ExternalLink>
  );
};

export default withStyles(styles)(Engage);
